import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7da7c49e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "break-crumb" }
const _hoisted_2 = {
  key: 0,
  class: "break-crumb__title"
}

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

type BreadcrumbItem = {
  key?: string;
  value: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const route = useRoute();
const { t, te } = useI18n();

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
  const list = (route.meta?.breadcrumb as BreadcrumbItem[]) || [];
  return Array.isArray(list) ? list : [];
});

const labelOf = (item: BreadcrumbItem) => {
  const key = item?.value?.trim() || "";
  if (!key) return "";
  return te(key) ? t(key) : key;
};

const pageTitle = computed(() => {
  const last = breadcrumbs.value[breadcrumbs.value.length - 1];
  if (last) return labelOf(last);
  const name = route.meta?.title || route.name;
  if (typeof name === "string" && te(name)) return t(name);
  return typeof name === "string" ? name : "";
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, {
      separator: ">",
      class: "break-crumb__nav"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
            default: _withCtx(() => [
              (item.key && index < breadcrumbs.value.length - 1)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.key,
                    class: "break-crumb__link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(labelOf(item)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["break-crumb__current", { 'break-crumb__current--last': index === breadcrumbs.value.length - 1 }])
                  }, _toDisplayString(labelOf(item)), 3))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (pageTitle.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(pageTitle.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})